import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-9dd8c80e")

_pushScopeId("data-v-9dd8c80e")
const _hoisted_1 = {
  key: 0,
  class: "doctor-list"
}
const _hoisted_2 = {
  key: 0,
  class: "-medium"
}
const _hoisted_3 = { class: "count-mydoctor" }
const _hoisted_4 = {
  key: 1,
  class: "doctor-list__empty view-card"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("p", null, "관심의사가 없습니다.", -1)
const _hoisted_6 = { class: "p-dialog-title" }
const _hoisted_7 = { class: "-royalBlue" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("님을 관심의사로 등록하였습니다. ")
const _hoisted_9 = { class: "doctor-description" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_DoctorItem = _resolveComponent("DoctorItem")
  const _component_Paginator = _resolveComponent("Paginator")
  const _component_OrderList = _resolveComponent("OrderList")
  const _component_Alert = _resolveComponent("Alert")
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.displayList && _ctx.displayList.length > 0)
      ? (_openBlock(), _createBlock("section", _hoisted_1, [
          _createVNode(_component_OrderList, {
            modelValue: _ctx.displayList,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.displayList = $event)),
            listStyle: _ctx.isHeightLimit ? 'height:40vh' : '',
            dataKey: "DoctorKey",
            "onUpdate:selection": _ctx.updateSelection,
            selection: _ctx.doctor.selectedDoctor,
            class: _ctx.isNotSelectable ? 'not-selectable' : 'selectable'
          }, _createSlots({
            filter: _withId(() => [
              (_ctx.$slots.title)
                ? (_openBlock(), _createBlock("div", _hoisted_2, [
                    _renderSlot(_ctx.$slots, "title", {}, undefined, true),
                    _createVNode("span", _hoisted_3, "(" + _toDisplayString(_ctx.countMyDoctor) + ")", 1)
                  ]))
                : _createCommentVNode("", true),
              (!!_ctx.props.isEditable)
                ? (_openBlock(), _createBlock(_component_Dropdown, {
                    key: 1,
                    modelValue: _ctx.depts.select,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.depts.select = $event)),
                    options: _ctx.depts.displayList,
                    optionLabel: "DeptName",
                    optionValue: "DeptKey",
                    placeholder: _ctx.t('Select a Dept'),
                    showClear: true,
                    class: "filter"
                  }, null, 8, ["modelValue", "options", "placeholder"]))
                : _createCommentVNode("", true)
            ]),
            item: _withId((slotProps) => [
              _createVNode(_component_DoctorItem, {
                doctor: slotProps.item
              }, {
                desc: _withId(() => [
                  _createVNode("span", {
                    class: "description-more -medium -royalBlue",
                    onClick: (event) => _ctx.opToggle(event, slotProps.item.Profiles)
                  }, "프로필 상세보기", 8, ["onClick"])
                ]),
                favorites: _withId(() => [
                  _createVNode("div", {
                    onClick: 
                (e) => {
                  _ctx.toggleFavorites(e, slotProps.item);
                }
              
                  }, [
                    _createVNode("i", {
                      class: ["pi", 
                  slotProps.item.MyDoctor === 0
                    ? 'pi-star'
                    : 'pi-star-o pi-star-fill'
                ],
                      style: {"fontsize":"2rem"}
                    }, null, 2)
                  ], 8, ["onClick"])
                ]),
                _: 2
              }, 1032, ["doctor"])
            ]),
            _: 2
          }, [
            (_ctx.doctor.selectedPage.length > 1)
              ? {
                  name: "footer",
                  fn: _withId(() => [
                    _createVNode(_component_Paginator, {
                      first: _ctx.doctor.selectedPage,
                      "onUpdate:first": _cache[2] || (_cache[2] = ($event: any) => (_ctx.doctor.selectedPage = $event)),
                      totalRecords: _ctx.doctor.selectedPage.length,
                      rows: 1
                    }, null, 8, ["first", "totalRecords"])
                  ])
                }
              : undefined
          ]), 1032, ["modelValue", "listStyle", "onUpdate:selection", "selection", "class"])
        ]))
      : (_openBlock(), _createBlock("section", _hoisted_4, [
          _hoisted_5
        ])),
    (!!_ctx.alert.content)
      ? (_openBlock(), _createBlock(_component_Alert, {
          key: 2,
          alert: _ctx.alert,
          "onUpdate:alert": _cache[4] || (_cache[4] = ($event: any) => (_ctx.alert = $event)),
          isConfirm: true,
          "onUpdate:clear": _cache[5] || (_cache[5] = 
      () => {
        _ctx.alert.content = '';
      }
    )
        }, {
          title: _withId(() => [
            _createVNode("span", _hoisted_6, [
              _createVNode("span", _hoisted_7, _toDisplayString(_ctx.selectMyDoctorName), 1),
              _hoisted_8
            ])
          ]),
          _: 1
        }, 8, ["alert"]))
      : _createCommentVNode("", true),
    _createVNode(_component_OverlayPanel, {
      showCloseIcon: true,
      ref: "op$"
    }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_9, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.descMore.split('\n'), (p, i) => {
            return (_openBlock(), _createBlock("span", { key: i }, _toDisplayString(p), 1))
          }), 128))
        ])
      ]),
      _: 1
    }, 512)
  ], 64))
})